import { type SyncStorage } from 'jotai/vanilla/utils/atomWithStorage';

// Custom storage that handles Date serialization/deserialization
export const dateAwareStorage: SyncStorage<any> = {
  getItem: (key: string, initialValue: any) => {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) {
      return initialValue;
    }
    try {
      // Parse with date reviver
      return JSON.parse(storedValue, (_key, value) => {
        // Check if the value looks like a date string
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
          return new Date(value);
        }
        return value;
      });
    } catch {
      return initialValue;
    }
  },
  setItem: (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: (key: string) => {
    localStorage.removeItem(key);
  },
  subscribe: (key: string, callback: (value: any) => void, initialValue: any) => {
    const listener = (e: StorageEvent) => {
      if (e.storageArea === localStorage && e.key === key) {
        let newValue;
        if (e.newValue === null) {
          newValue = initialValue;
        } else {
          try {
            // Parse with date reviver
            newValue = JSON.parse(e.newValue, (_key, value) => {
              if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
                return new Date(value);
              }
              return value;
            });
          } catch {
            newValue = initialValue;
          }
        }
        callback(newValue);
      }
    };
    window.addEventListener('storage', listener);
    return () => {
      window.removeEventListener('storage', listener);
    };
  },
};